import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getOrder } from "../../redux/actions/orders";

export default function OrderDetailAdmin() {
  const { id } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrder({ id }));
  }, [dispatch, id]);

  const { order } = useSelector((state) => state.orders);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  console.log("ORDER", order);

  const {
    fives,
    tens,
    fifteens,
    twenty_fives,
    fifties,
    hundreds,
    orderNo,
    createdAt,
  } = order;

  const handleSum = () => {
    const sum =
      fives * 5 +
      tens * 10 +
      fifteens * 15 +
      twenty_fives * 25 +
      fifties * 50 +
      hundreds * 100;

    return sum;
  };

  return (
    <>
      {order !== null && (
        <div className="mt-10 lg:mt-5 px-20">
          <h2 className="text-lg font-medium text-gray-900">
            Order Details of Order: {orderNo}
          </h2>
          <p className="text-gray-500 italic">{formatDate(createdAt)}</p>

          <div className="mt-4 bg-white border border-gray-200 rounded-lg shadow-sm">
            <h3 className="sr-only">Items in your order</h3>

            <dl className="items-center border-t border-gray-200 py-6 px-4 sm:px-6 divide-y divide-gray-200">
              <div className="py-2 grid grid-cols-3 divide-x text-center">
                <div className="text-sm font-medium">Type</div>
                <div className="text-sm font-medium text-gray-900">
                  Quantity
                </div>
                <div className="text-sm font-medium text-gray-900">Price</div>
              </div>
              <div className="py-2 grid grid-cols-3 divide-x text-center">
                <div className="text-sm">Fives</div>
                <div className="text-sm font-medium text-gray-900">{fives}</div>
                <div className="text-sm font-medium text-gray-900">
                  {fives * 5}
                </div>
              </div>
              <div className="py-2 grid grid-cols-3 divide-x text-center">
                <div className="text-sm">Tens</div>
                <div className="text-sm font-medium text-gray-900">{tens}</div>
                <div className="text-sm font-medium text-gray-900">
                  {tens * 10}
                </div>
              </div>
              <div className="py-2 grid grid-cols-3 divide-x text-center">
                <div className="text-sm">Fifteens</div>
                <div className="text-sm font-medium text-gray-900">
                  {fifteens}
                </div>
                <div className="text-sm font-medium text-gray-900">
                  {fifteens * 15}
                </div>
              </div>
              <div className="py-2 grid grid-cols-3 divide-x text-center">
                <div className="text-sm">Twenty fives</div>
                <div className="text-sm font-medium text-gray-900">
                  {twenty_fives}
                </div>
                <div className="text-sm font-medium text-gray-900">
                  {twenty_fives * 25}
                </div>
              </div>
              <div className="py-2 grid grid-cols-3 divide-x text-center">
                <div className="text-sm">Fifties</div>
                <div className="text-sm font-medium text-gray-900">
                  {fifties}
                </div>
                <div className="text-sm font-medium text-gray-900">
                  {fifties * 50}
                </div>
              </div>
              <div className="py-2 grid grid-cols-3 divide-x text-center">
                <div className="text-sm">Hundreds</div>
                <div className="text-sm font-medium text-gray-900">
                  {hundreds}
                </div>
                <div className="text-sm font-medium text-gray-900">
                  {hundreds * 100}
                </div>
              </div>
              <div className="py-2 grid grid-cols-3 text-center border-t border-gray-200 pt-6">
                <div className="text-base font-medium underline underline-offset-1">
                  Total
                </div>
                <div></div>
                <div className="text-base font-medium text-gray-900 underline underline-offset-1">
                  {handleSum()}
                </div>
              </div>
            </dl>
          </div>
        </div>
      )}
    </>
  );
}
